import { render, staticRenderFns } from "./PlayerAlternative.vue?vue&type=template&id=74982a57&scoped=true"
import script from "./PlayerAlternative.vue?vue&type=script&lang=js"
export * from "./PlayerAlternative.vue?vue&type=script&lang=js"
import style0 from "./PlayerAlternative.vue?vue&type=style&index=0&id=74982a57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74982a57",
  null
  
)

export default component.exports